var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.65,
    y: 1.65,
    width: 16.7,
    height: 20.7,
    rx: 1.35,
    stroke: "#1B3E61",
    strokeWidth: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#1B3E61",
    stroke: "#1B3E61",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#1B3E61",
    stroke: "#1B3E61",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#1B3E61",
    stroke: "#1B3E61",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedFeedIcon);
export default __webpack_public_path__ + "static/media/updated_feed_icon.3b7c612c2099e6980836661decb6e17a.svg";
export { ForwardRef as ReactComponent };